<template>
    <div class="content-box first">
        <div class="page-list-box">
            <el-table v-loading="listLoading" ref="dataList" :data="dataList" style="width: 100%" stripe>
                <el-table-column label="合同" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <router-link v-if="scope.row.fddViewpdfUrl" :to="`contractauthorizationdetail?id=${scope.row.id}&url=${encodeURIComponent(scope.row.fddFullLocalpdfUrl)}&type=contract`
                            ">
                            {{ scope.row.code }}
                        </router-link>
                        <router-link v-else-if="scope.row.letSignContractUrl" :to="`contractauthorizationdetail?id=${scope.row.id}&url=${encodeURIComponent(
                            getFpdUrl(scope.row.letSignContractUrl)
                        )}&type=contract`
                            ">
                            {{ scope.row.code }}
                        </router-link>
                        <p v-else>{{ scope.row.code }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="合同签署日期">
                    <template slot-scope="scope">
                        <span>{{ $utils.formatDate(scope.row.startTime) }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="合同结束时间">
                    <template slot-scope="scope">
                        <span>{{ $utils.formatDate(scope.row.endTime) }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text"
                            @click="$router.push({ path: '/manage/album/list', query: { contractNo: scope.row.code } })">
                            查看作品
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="prev, pager, next" :total="data.totalCount || 0"></el-pagination>
        </div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo: 1
};
export default {
    data() {
        return {
            listLoading: false,
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            }
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        getFpdUrl(url) {
            const fileUrl = this.$store.state.config && this.$store.state.config.fileUrl;
            return fileUrl + url;
        },
        //获取列表数据
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: '/contractController/view/getContractList',
                params: { ...this.params }
            })
                .then(res => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        }
    }
};
</script>
